export default {
  contentDefinitions: [
    {
      id: 'api.error',
      loadUri: '~/tenant/templates/AzureBlue/exception.cshtml',
      recoveryUri: '~/common/default_page_error.html',
      dataUri: 'urn:com:microsoft:aad:b2c:elements:contract:globalexception:1.2.1',
      metadata: [{ key: 'DisplayName', value: 'Error page' }],
    },
    {
      id: 'api.idpselections',
      loadUri: '~/tenant/templates/AzureBlue/idpSelector.cshtml',
      recoveryUri: '~/common/default_page_error.html',
      dataUri: 'urn:com:microsoft:aad:b2c:elements:contract:providerselection:1.2.1',
      metadata: [
        { key: 'DisplayName', value: 'Idp selection page' },
        { key: 'language.intro', value: 'Sign in' },
      ],
      localizedResourcesRefs: {
        mergeBehavior: 'Prepend',
        localizedResourcesRefs: [{ language: 'en', localizedResourcesReferenceId: 'api.idpselections.en' }],
      },
    },
    {
      id: 'api.idpselections.signup',
      loadUri: '~/tenant/templates/AzureBlue/idpSelector.cshtml',
      recoveryUri: '~/common/default_page_error.html',
      dataUri: 'urn:com:microsoft:aad:b2c:elements:contract:providerselection:1.2.1',
      metadata: [
        { key: 'DisplayName', value: 'Idp selection page' },
        { key: 'language.intro', value: 'Sign up' },
      ],
    },
    {
      id: 'api.signuporsignin',
      loadUri: '~/tenant/templates/AzureBlue/unified.cshtml',
      recoveryUri: '~/common/default_page_error.html',
      dataUri: 'urn:com:microsoft:aad:b2c:elements:contract:unifiedssp:2.1.5',
      metadata: [{ key: 'DisplayName', value: 'Signin and Signup' }],
      localizedResourcesRefs: {
        mergeBehavior: 'Prepend',
        localizedResourcesRefs: [{ language: 'en', localizedResourcesReferenceId: 'api.signuporsignin.en' }],
      },
    },
    {
      id: 'api.selfasserted',
      loadUri: '~/tenant/templates/AzureBlue/selfAsserted.cshtml',
      recoveryUri: '~/common/default_page_error.html',
      dataUri: 'urn:com:microsoft:aad:b2c:elements:contract:selfasserted:2.1.7',
      metadata: [{ key: 'DisplayName', value: 'Collect information from user page' }],
    },
    {
      id: 'api.selfasserted.profileupdate',
      loadUri: '~/tenant/templates/AzureBlue/selfAsserted.cshtml',
      recoveryUri: '~/common/default_page_error.html',
      dataUri: 'urn:com:microsoft:aad:b2c:elements:contract:selfasserted:2.1.7',
      metadata: [{ key: 'DisplayName', value: 'Collect information from user page' }],
      localizedResourcesRefs: {
        mergeBehavior: 'Prepend',
        localizedResourcesRefs: [
          { language: 'en', localizedResourcesReferenceId: 'api.selfasserted.profileupdate.en' },
        ],
      },
    },
    {
      id: 'api.localaccountsignup',
      loadUri: '~/tenant/templates/AzureBlue/selfAsserted.cshtml',
      recoveryUri: '~/common/default_page_error.html',
      dataUri: 'urn:com:microsoft:aad:b2c:elements:contract:selfasserted:2.1.7',
      metadata: [{ key: 'DisplayName', value: 'Local account sign up page' }],
      localizedResourcesRefs: {
        mergeBehavior: 'Prepend',
        localizedResourcesRefs: [{ language: 'en', localizedResourcesReferenceId: 'api.localaccountsignup.en' }],
      },
    },
    {
      id: 'api.localaccountpasswordreset',
      loadUri: '~/tenant/templates/AzureBlue/selfAsserted.cshtml',
      recoveryUri: '~/common/default_page_error.html',
      dataUri: 'urn:com:microsoft:aad:b2c:elements:contract:selfasserted:2.1.7',
      metadata: [{ key: 'DisplayName', value: 'Local account change password page' }],
      localizedResourcesRefs: {
        mergeBehavior: 'Prepend',
        localizedResourcesRefs: [{ language: 'en', localizedResourcesReferenceId: 'api.localaccountpasswordreset.en' }],
      },
    },
    {
      id: 'api.socialccountsignup',
      loadUri: '~/tenant/templates/AzureBlue/selfAsserted.cshtml',
      recoveryUri: '~/common/default_page_error.html',
      dataUri: 'urn:com:microsoft:aad:b2c:elements:contract:selfasserted:2.1.7',
      metadata: [{ key: 'DisplayName', value: 'Collect information from user page' }],
      localizedResourcesRefs: {
        mergeBehavior: 'Prepend',
        localizedResourcesRefs: [{ language: 'en', localizedResourcesReferenceId: 'api.socialccountsignup.en' }],
      },
    },
    {
      id: 'api.localaccountsignin',
      loadUri: '~/tenant/templates/AzureBlue/selfAsserted.cshtml',
      recoveryUri: '~/common/default_page_error.html',
      dataUri: 'urn:com:microsoft:aad:b2c:elements:contract:selfasserted:2.1.7',
      metadata: [{ key: 'DisplayName', value: 'Collect information from user page' }],
      localizedResourcesRefs: {
        mergeBehavior: 'Prepend',
        localizedResourcesRefs: [{ language: 'en', localizedResourcesReferenceId: 'api.localaccountsignin.en' }],
      },
    },
    {
      id: 'api.phonefactor',
      loadUri: '~/tenant/templates/AzureBlue/multifactor-1.0.0.cshtml',
      recoveryUri: '~/common/default_page_error.html',
      dataUri: 'urn:com:microsoft:aad:b2c:elements:contract:multifactor:1.2.5',
      metadata: [{ key: 'DisplayName', value: 'Multi-factor authentication page' }],
      localizedResourcesRefs: {
        mergeBehavior: 'Prepend',
        localizedResourcesRefs: [{ language: 'en', localizedResourcesReferenceId: 'api.phonefactor.en' }],
      },
    },
  ],
  supportedLanguages: { defaultLanguage: 'en', mergeBehavior: 'Append', languages: ['en'] },
  localizedResources: [
    {
      id: 'api.signuporsignin.en',
      strings: [
        {
          elementType: 'ClaimType',
          elementId: 'signInName',
          stringId: 'DisplayName',
          value: 'Email Address',
        },
        {
          elementType: 'UxElement',
          stringId: 'heading',
          value: 'Sign in',
        },
        {
          elementType: 'UxElement',
          stringId: 'social_intro',
          value: 'Other options',
        },
        {
          elementType: 'UxElement',
          stringId: 'local_intro_generic',
          value: 'Sign in with your {0}',
        },
        {
          elementType: 'ClaimType',
          elementId: 'password',
          stringId: 'DisplayName',
          value: 'Password',
        },
        {
          elementType: 'UxElement',
          stringId: 'requiredField_password',
          value: 'Please enter your password',
        },
        {
          elementType: 'UxElement',
          stringId: 'requiredField_generic',
          value: 'Please enter your {0}',
        },
        {
          elementType: 'UxElement',
          stringId: 'invalid_generic',
          value: 'Please enter a valid {0}',
        },
        {
          elementType: 'UxElement',
          stringId: 'createaccount_one_link',
          value: 'Sign up now',
        },
        {
          elementType: 'UxElement',
          stringId: 'createaccount_two_links',
          value: 'Sign up with {0} or {1}',
        },
        {
          elementType: 'UxElement',
          stringId: 'createaccount_three_links',
          value: 'Sign up with {0}, {1}, or {2}',
        },
        {
          elementType: 'UxElement',
          stringId: 'forgotpassword_link',
          value: 'Forgot your password?',
        },
        {
          elementType: 'UxElement',
          stringId: 'button_signin',
          value: 'Sign in',
        },
        {
          elementType: 'UxElement',
          stringId: 'divider_title',
          value: 'OR',
        },
        {
          elementType: 'UxElement',
          stringId: 'createaccount_intro',
          value: "Don't have an account?",
        },
        {
          elementType: 'UxElement',
          stringId: 'unknown_error',
          value: 'We are having trouble signing you in. Please try again later.',
        },
        {
          elementType: 'UxElement',
          stringId: 'remember_me',
          value: 'Keep me signed in',
        },
        {
          elementType: 'ClaimsProvider',
          stringId: 'FacebookExchange',
          value: 'Facebook',
        },
        {
          elementType: 'ErrorMessage',
          stringId: 'ResourceOwnerFlowInvalidCredentials',
          value: 'Your password is incorrect.',
        },
        {
          elementType: 'ErrorMessage',
          stringId: 'UserMessageIfInvalidPassword',
          value: 'Your password is incorrect.',
        },
        {
          elementType: 'ErrorMessage',
          stringId: 'UserMessageIfPasswordExpired',
          value: 'Your password has expired.',
        },
        {
          elementType: 'ErrorMessage',
          stringId: 'UserMessageIfClaimsPrincipalDoesNotExist',
          value: "We can't seem to find your account.",
        },
        {
          elementType: 'ErrorMessage',
          stringId: 'UserMessageIfOldPasswordUsed',
          value: 'Looks like you used an old password.',
        },
        {
          elementType: 'ErrorMessage',
          stringId: 'DefaultMessage',
          value: 'Invalid username or password.',
        },
        {
          elementType: 'ErrorMessage',
          stringId: 'UserMessageIfUserAccountDisabled',
          value: 'Your account has been locked. Contact your support person to unlock it, then try again.',
        },
        {
          elementType: 'ErrorMessage',
          stringId: 'UserMessageIfUserAccountLocked',
          value: 'Your account is temporarily locked to prevent unauthorized use. Try again later.',
        },
        {
          elementType: 'ErrorMessage',
          stringId: 'AADRequestsThrottled',
          value: 'There are too many requests at this moment. Please wait for some time and try again.',
        },
      ],
    },
    {
      id: 'api.localaccountsignup.en',
      strings: [
        {
          elementType: 'ClaimType',
          elementId: 'email',
          stringId: 'DisplayName',
          value: 'Email Address',
        },
        {
          elementType: 'ClaimType',
          elementId: 'email',
          stringId: 'UserHelpText',
          value: 'Email address that can be used to contact you.',
        },
        {
          elementType: 'ClaimType',
          elementId: 'email',
          stringId: 'PatternHelpText',
          value: 'Please enter a valid email address.',
        },
        {
          elementType: 'ClaimType',
          elementId: 'newPassword',
          stringId: 'DisplayName',
          value: 'New Password',
        },
        {
          elementType: 'ClaimType',
          elementId: 'newPassword',
          stringId: 'UserHelpText',
          value: 'Enter new password',
        },
        {
          elementType: 'ClaimType',
          elementId: 'newPassword',
          stringId: 'PatternHelpText',
          value:
            '8-16 characters, containing 3 out of 4 of the following: Lowercase characters, uppercase characters, digits (0-9), and one or more of the following symbols: @ # $ % ^ &amp; * - _ + = [ ] { } |  : \' , ? / ` ~ " ( ) ; .',
        },
        {
          elementType: 'ClaimType',
          elementId: 'reenterPassword',
          stringId: 'DisplayName',
          value: 'Confirm New Password',
        },
        {
          elementType: 'ClaimType',
          elementId: 'reenterPassword',
          stringId: 'UserHelpText',
          value: 'Confirm new password',
        },
        {
          elementType: 'ClaimType',
          elementId: 'reenterPassword',
          stringId: 'PatternHelpText',
          value:
            '8-16 characters, containing 3 out of 4 of the following: Lowercase characters, uppercase characters, digits (0-9), and one or more of the following symbols: @ # $ % ^ &amp; * - _ + = [ ] { } |  : \' , ? / ` ~ " ( ) ; .',
        },
        {
          elementType: 'ClaimType',
          elementId: 'displayName',
          stringId: 'DisplayName',
          value: 'Display Name',
        },
        {
          elementType: 'ClaimType',
          elementId: 'displayName',
          stringId: 'UserHelpText',
          value: 'Your display name.',
        },
        {
          elementType: 'ClaimType',
          elementId: 'surname',
          stringId: 'DisplayName',
          value: 'Surname',
        },
        {
          elementType: 'ClaimType',
          elementId: 'surname',
          stringId: 'UserHelpText',
          value: 'Your surname (also known as family name or last name).',
        },
        {
          elementType: 'ClaimType',
          elementId: 'givenName',
          stringId: 'DisplayName',
          value: 'Given Name',
        },
        {
          elementType: 'ClaimType',
          elementId: 'givenName',
          stringId: 'UserHelpText',
          value: 'Your given name (also known as first name).',
        },
        {
          elementType: 'UxElement',
          stringId: 'button_continue',
          value: 'Create',
        },
        {
          elementType: 'UxElement',
          stringId: 'error_fieldIncorrect',
          value: 'One or more fields are filled out incorrectly. Please check your entries and try again.',
        },
        {
          elementType: 'UxElement',
          stringId: 'error_passwordEntryMismatch',
          value: 'The password entry fields do not match. Please enter the same password in both fields and try again.',
        },
        {
          elementType: 'UxElement',
          stringId: 'error_requiredFieldMissing',
          value: 'A required field is missing. Please fill out all required fields and try again.',
        },
        {
          elementType: 'UxElement',
          stringId: 'helplink_text',
          value: 'What is this?',
        },
        {
          elementType: 'UxElement',
          stringId: 'initial_intro',
          value: 'Please provide the following details.',
        },
        {
          elementType: 'UxElement',
          stringId: 'preloader_alt',
          value: 'Please wait',
        },
        {
          elementType: 'UxElement',
          stringId: 'required_field',
          value: 'This information is required.',
        },
        {
          elementType: 'UxElement',
          stringId: 'button_cancel',
          value: 'Cancel',
        },
        {
          elementType: 'UxElement',
          stringId: 'ver_but_edit',
          value: 'Change e-mail',
        },
        {
          elementType: 'UxElement',
          stringId: 'ver_but_resend',
          value: 'Send new code',
        },
        {
          elementType: 'UxElement',
          stringId: 'ver_but_send',
          value: 'Send verification code',
        },
        {
          elementType: 'UxElement',
          stringId: 'ver_but_verify',
          value: 'Verify code',
        },
        {
          elementType: 'UxElement',
          stringId: 'ver_fail_code_expired',
          value: 'That code is expired. Please request a new code.',
        },
        {
          elementType: 'UxElement',
          stringId: 'ver_fail_no_retry',
          value: "You've made too many incorrect attempts. Please try again later.",
        },
        {
          elementType: 'UxElement',
          stringId: 'ver_fail_retry',
          value: 'That code is incorrect. Please try again.',
        },
        {
          elementType: 'UxElement',
          stringId: 'ver_fail_server',
          value:
            'We are having trouble verifying your email address. Please enter a valid email address and try again.',
        },
        {
          elementType: 'UxElement',
          stringId: 'ver_fail_throttled',
          value: 'There have been too many requests to verify this email address. Please wait a while, then try again.',
        },
        {
          elementType: 'UxElement',
          stringId: 'ver_info_msg',
          value: 'Verification code has been sent to your inbox. Please copy it to the input box below.',
        },
        {
          elementType: 'UxElement',
          stringId: 'ver_input',
          value: 'Verification code',
        },
        {
          elementType: 'UxElement',
          stringId: 'ver_intro_msg',
          value: 'Verification is necessary. Please click Send button.',
        },
        {
          elementType: 'UxElement',
          stringId: 'ver_success_msg',
          value: 'E-mail address verified. You can now continue.',
        },
        {
          elementType: 'ErrorMessage',
          stringId: 'ServiceThrottled',
          value: 'There are too many requests at this moment. Please wait for some time and try again.',
        },
        {
          elementType: 'ErrorMessage',
          stringId: 'UserMessageIfClaimNotVerified',
          value: 'Claim not verified: {0}',
        },
        {
          elementType: 'ErrorMessage',
          stringId: 'UserMessageIfClaimsPrincipalAlreadyExists',
          value: 'A user with the specified ID already exists. Please choose a different one.',
        },
        {
          elementType: 'ErrorMessage',
          stringId: 'UserMessageIfIncorrectPattern',
          value: 'Incorrect pattern for: {0}',
        },
        {
          elementType: 'ErrorMessage',
          stringId: 'UserMessageIfInvalidInput',
          value: '{0} has invalid input.',
        },
        {
          elementType: 'ErrorMessage',
          stringId: 'UserMessageIfMissingRequiredElement',
          value: 'Missing required element: {0}',
        },
        {
          elementType: 'ErrorMessage',
          stringId: 'UserMessageIfValidationError',
          value: 'Error in validation by: {0}',
        },
      ],
    },
    {
      id: 'api.socialccountsignup.en',
      strings: [
        {
          elementType: 'ClaimType',
          elementId: 'email',
          stringId: 'DisplayName',
          value: 'Email Address',
        },
        {
          elementType: 'ClaimType',
          elementId: 'email',
          stringId: 'UserHelpText',
          value: 'Email address that can be used to contact you.',
        },
        {
          elementType: 'ClaimType',
          elementId: 'email',
          stringId: 'PatternHelpText',
          value: 'Please enter a valid email address.',
        },
        {
          elementType: 'ClaimType',
          elementId: 'displayName',
          stringId: 'DisplayName',
          value: 'Display Name',
        },
        {
          elementType: 'ClaimType',
          elementId: 'displayName',
          stringId: 'UserHelpText',
          value: 'Your display name.',
        },
        {
          elementType: 'ClaimType',
          elementId: 'surname',
          stringId: 'DisplayName',
          value: 'Surname',
        },
        {
          elementType: 'ClaimType',
          elementId: 'surname',
          stringId: 'UserHelpText',
          value: 'Your surname (also known as family name or last name).',
        },
        {
          elementType: 'ClaimType',
          elementId: 'givenName',
          stringId: 'DisplayName',
          value: 'Given Name',
        },
        {
          elementType: 'ClaimType',
          elementId: 'givenName',
          stringId: 'UserHelpText',
          value: 'Your given name (also known as first name).',
        },
        {
          elementType: 'UxElement',
          stringId: 'button_continue',
          value: 'Create',
        },
        {
          elementType: 'UxElement',
          stringId: 'button_cancel',
          value: 'Cancel',
        },
        {
          elementType: 'ErrorMessage',
          stringId: 'UserMessageIfClaimsPrincipalAlreadyExists',
          value: 'You are already registered, please press the back button and sign in instead.',
        },
      ],
    },
    {
      id: 'api.localaccountpasswordreset.en',
      strings: [
        {
          elementType: 'ClaimType',
          elementId: 'email',
          stringId: 'DisplayName',
          value: 'Email Address',
        },
        {
          elementType: 'ClaimType',
          elementId: 'email',
          stringId: 'UserHelpText',
          value: 'Email address that can be used to contact you.',
        },
        {
          elementType: 'ClaimType',
          elementId: 'email',
          stringId: 'PatternHelpText',
          value: 'Please enter a valid email address.',
        },
        {
          elementType: 'ClaimType',
          elementId: 'newPassword',
          stringId: 'DisplayName',
          value: 'New Password',
        },
        {
          elementType: 'ClaimType',
          elementId: 'newPassword',
          stringId: 'UserHelpText',
          value: 'Enter new password',
        },
        {
          elementType: 'ClaimType',
          elementId: 'newPassword',
          stringId: 'PatternHelpText',
          value:
            '8-16 characters, containing 3 out of 4 of the following: Lowercase characters, uppercase characters, digits (0-9), and one or more of the following symbols: @ # $ % ^ &amp; * - _ + = [ ] { } |  : \' , ? / ` ~ " ( ) ; .',
        },
        {
          elementType: 'ClaimType',
          elementId: 'reenterPassword',
          stringId: 'DisplayName',
          value: 'Confirm New Password',
        },
        {
          elementType: 'ClaimType',
          elementId: 'reenterPassword',
          stringId: 'UserHelpText',
          value: 'Confirm new password',
        },
        {
          elementType: 'ClaimType',
          elementId: 'reenterPassword',
          stringId: 'PatternHelpText',
          value:
            '8-16 characters, containing 3 out of 4 of the following: Lowercase characters, uppercase characters, digits (0-9), and one or more of the following symbols: @ # $ % ^ &amp; * - _ + = [ ] { } |  : \' , ? / ` ~ " ( ) ; .',
        },
        {
          elementType: 'UxElement',
          stringId: 'error_passwordEntryMismatch',
          value: 'The password entry fields do not match. Please enter the same password in both fields and try again.',
        },
        {
          elementType: 'UxElement',
          stringId: 'error_fieldIncorrect',
          value: 'One or more fields are filled out incorrectly. Please check your entries and try again.',
        },
        {
          elementType: 'UxElement',
          stringId: 'button_continue',
          value: 'Continue',
        },
        {
          elementType: 'UxElement',
          stringId: 'button_cancel',
          value: 'Cancel',
        },
        {
          elementType: 'ErrorMessage',
          stringId: 'UserMessageIfClaimsPrincipalDoesNotExist',
          value: 'An account could not be found for the provided user ID.',
        },
        {
          elementType: 'ErrorMessage',
          stringId: 'UserMessageIfClaimsTransformationBooleanValueIsNotEqual',
          value: 'Your account has been locked. Contact your support person to unlock it, then try again.',
        },
        {
          elementType: 'UxElement',
          stringId: 'required_field',
          value: 'This information is required.',
        },
        {
          elementType: 'UxElement',
          stringId: 'ver_but_edit',
          value: 'Change e-mail',
        },
        {
          elementType: 'UxElement',
          stringId: 'ver_but_resend',
          value: 'Send new code',
        },
        {
          elementType: 'UxElement',
          stringId: 'ver_but_send',
          value: 'Send verification code',
        },
        {
          elementType: 'UxElement',
          stringId: 'ver_but_verify',
          value: 'Verify code',
        },
        {
          elementType: 'UxElement',
          stringId: 'ver_fail_code_expired',
          value: 'That code is expired. Please request a new code.',
        },
        {
          elementType: 'UxElement',
          stringId: 'ver_fail_no_retry',
          value: "You've made too many incorrect attempts. Please try again later.",
        },
        {
          elementType: 'UxElement',
          stringId: 'ver_fail_retry',
          value: 'That code is incorrect. Please try again.',
        },
        {
          elementType: 'UxElement',
          stringId: 'ver_fail_server',
          value:
            'We are having trouble verifying your email address. Please enter a valid email address and try again.',
        },
        {
          elementType: 'UxElement',
          stringId: 'ver_fail_throttled',
          value: 'There have been too many requests to verify this email address. Please wait a while, then try again.',
        },
        {
          elementType: 'UxElement',
          stringId: 'ver_info_msg',
          value: 'Verification code has been sent to your inbox. Please copy it to the input box below.',
        },
        {
          elementType: 'UxElement',
          stringId: 'ver_input',
          value: 'Verification code',
        },
        {
          elementType: 'UxElement',
          stringId: 'ver_intro_msg',
          value: 'Verification is necessary. Please click Send button.',
        },
        {
          elementType: 'UxElement',
          stringId: 'ver_success_msg',
          value: 'E-mail address verified. You can now continue.',
        },
        {
          elementType: 'ErrorMessage',
          stringId: 'ServiceThrottled',
          value: 'There are too many requests at this moment. Please wait for some time and try again.',
        },
        {
          elementType: 'ErrorMessage',
          stringId: 'UserMessageIfClaimNotVerified',
          value: 'Claim not verified: {0}',
        },
        {
          elementType: 'ErrorMessage',
          stringId: 'UserMessageIfClaimsPrincipalAlreadyExists',
          value: 'A user with the specified ID already exists. Please choose a different one.',
        },
        {
          elementType: 'ErrorMessage',
          stringId: 'UserMessageIfIncorrectPattern',
          value: 'Incorrect pattern for: {0}',
        },
        {
          elementType: 'ErrorMessage',
          stringId: 'UserMessageIfInvalidInput',
          value: '{0} has invalid input.',
        },
        {
          elementType: 'ErrorMessage',
          stringId: 'UserMessageIfMissingRequiredElement',
          value: 'Missing required element: {0}',
        },
        {
          elementType: 'ErrorMessage',
          stringId: 'UserMessageIfValidationError',
          value: 'Error in validation by: {0}',
        },
      ],
    },
    {
      id: 'api.idpselections.en',
      strings: [
        {
          elementType: 'UxElement',
          stringId: 'intro',
          value: 'Sign in',
        },
        {
          elementType: 'ClaimsProvider',
          stringId: 'LocalAccountSigninEmailExchange',
          value: 'Local Account Signin',
        },
        {
          elementType: 'ClaimsProvider',
          stringId: 'FacebookExchange',
          value: 'Facebook',
        },
      ],
    },
    {
      id: 'api.localaccountsignin.en',
      strings: [
        {
          elementType: 'ClaimType',
          elementId: 'signInName',
          stringId: 'DisplayName',
          value: 'Email Address',
        },
        {
          elementType: 'ClaimType',
          elementId: 'password',
          stringId: 'DisplayName',
          value: 'Password',
        },
        {
          elementType: 'UxElement',
          stringId: 'button_continue',
          value: 'Continue',
        },
        {
          elementType: 'UxElement',
          stringId: 'button_cancel',
          value: 'Cancel',
        },
        {
          elementType: 'ErrorMessage',
          stringId: 'ResourceOwnerFlowInvalidCredentials',
          value: 'Your password is incorrect.',
        },
        {
          elementType: 'ErrorMessage',
          stringId: 'UserMessageIfInvalidPassword',
          value: 'Your password is incorrect.',
        },
        {
          elementType: 'ErrorMessage',
          stringId: 'UserMessageIfPasswordExpired',
          value: 'Your password has expired.',
        },
        {
          elementType: 'ErrorMessage',
          stringId: 'UserMessageIfClaimsPrincipalDoesNotExist',
          value: "We can't seem to find your account.",
        },
        {
          elementType: 'ErrorMessage',
          stringId: 'UserMessageIfOldPasswordUsed',
          value: 'Looks like you used an old password.',
        },
        {
          elementType: 'ErrorMessage',
          stringId: 'DefaultMessage',
          value: 'Invalid username or password.',
        },
        {
          elementType: 'ErrorMessage',
          stringId: 'UserMessageIfUserAccountDisabled',
          value: 'Your account has been locked. Contact your support person to unlock it, then try again.',
        },
        {
          elementType: 'ErrorMessage',
          stringId: 'UserMessageIfUserAccountLocked',
          value: 'Your account is temporarily locked to prevent unauthorized use. Try again later.',
        },
        {
          elementType: 'ErrorMessage',
          stringId: 'AADRequestsThrottled',
          value: 'There are too many requests at this moment. Please wait for some time and try again.',
        },
      ],
    },
    {
      id: 'api.selfasserted.profileupdate.en',
      strings: [
        {
          elementType: 'ClaimType',
          elementId: 'displayName',
          stringId: 'DisplayName',
          value: 'Display Name',
        },
        {
          elementType: 'ClaimType',
          elementId: 'displayName',
          stringId: 'UserHelpText',
          value: 'Your display name.',
        },
        {
          elementType: 'ClaimType',
          elementId: 'surname',
          stringId: 'DisplayName',
          value: 'Surname',
        },
        {
          elementType: 'ClaimType',
          elementId: 'surname',
          stringId: 'UserHelpText',
          value: 'Your surname (also known as family name or last name).',
        },
        {
          elementType: 'ClaimType',
          elementId: 'givenName',
          stringId: 'DisplayName',
          value: 'Given Name',
        },
        {
          elementType: 'ClaimType',
          elementId: 'givenName',
          stringId: 'UserHelpText',
          value: 'Your given name (also known as first name).',
        },
        {
          elementType: 'UxElement',
          stringId: 'button_continue',
          value: 'Continue',
        },
        {
          elementType: 'UxElement',
          stringId: 'button_cancel',
          value: 'Cancel',
        },
      ],
    },
    {
      id: 'api.phonefactor.en',
      strings: [
        {
          elementType: 'UxElement',
          stringId: 'button_verify',
          value: 'Call Me',
        },
        {
          elementType: 'UxElement',
          stringId: 'country_code_label',
          value: 'Country Code',
        },
        {
          elementType: 'UxElement',
          stringId: 'cancel_message',
          value: 'The user has canceled multi-factor authentication',
        },
        {
          elementType: 'UxElement',
          stringId: 'text_button_send_second_code',
          value: 'Send a new code',
        },
        {
          elementType: 'UxElement',
          stringId: 'code_pattern',
          value: '\\d{6}',
        },
        {
          elementType: 'UxElement',
          stringId: 'intro_mixed',
          value:
            'We have the following number on record for you. We can send a code via SMS or phone to authenticate you.',
        },
        {
          elementType: 'UxElement',
          stringId: 'intro_mixed_p',
          value:
            'We have the following numbers on record for you. Choose a number that we can phone or send a code via SMS to authenticate you.',
        },
        {
          elementType: 'UxElement',
          stringId: 'button_verify_code',
          value: 'Verify Code',
        },
        {
          elementType: 'UxElement',
          stringId: 'requiredField_code',
          value: 'Please enter the verification code you received',
        },
        {
          elementType: 'UxElement',
          stringId: 'invalid_code',
          value: 'Please enter the 6-digit code you received',
        },
        {
          elementType: 'UxElement',
          stringId: 'button_cancel',
          value: 'Cancel',
        },
        {
          elementType: 'UxElement',
          stringId: 'local_number_input_placeholder_text',
          value: 'Phone number',
        },
        {
          elementType: 'UxElement',
          stringId: 'button_retry',
          value: 'Retry',
        },
        {
          elementType: 'UxElement',
          stringId: 'alternative_text',
          value: "I don't have my phone",
        },
        {
          elementType: 'UxElement',
          stringId: 'intro_phone_p',
          value:
            'We have the following numbers on record for you. Choose a number that we can phone to authenticate you.',
        },
        {
          elementType: 'UxElement',
          stringId: 'intro_phone',
          value: 'We have the following number on record for you. We will phone to authenticate you.',
        },
        {
          elementType: 'UxElement',
          stringId: 'enter_code_text_intro',
          value: 'Enter your verification code below, or',
        },
        {
          elementType: 'UxElement',
          stringId: 'intro_entry_phone',
          value: 'Enter a number below that we can phone to authenticate you.',
        },
        {
          elementType: 'UxElement',
          stringId: 'intro_entry_sms',
          value: 'Enter a number below that we can send a code via SMS to authenticate you.',
        },
        {
          elementType: 'UxElement',
          stringId: 'button_send_code',
          value: 'Send Code',
        },
        {
          elementType: 'UxElement',
          stringId: 'invalid_number',
          value: 'Please enter a valid phone number',
        },
        {
          elementType: 'UxElement',
          stringId: 'intro_sms',
          value: 'We have the following number on record for you. We will send a code via SMS to authenticate you.',
        },
        {
          elementType: 'UxElement',
          stringId: 'intro_entry_mixed',
          value: 'Enter a number below that we can send a code via SMS or phone to authenticate you.',
        },
        {
          elementType: 'UxElement',
          stringId: 'number_pattern',
          value: '^\\+(?:[0-9][\\x20-]?){6,14}[0-9]$',
        },
        {
          elementType: 'UxElement',
          stringId: 'intro_sms_p',
          value:
            'We have the following numbers on record for you. Choose a number that we can send a code via SMS to authenticate you.',
        },
        {
          elementType: 'UxElement',
          stringId: 'requiredField_countryCode',
          value: 'Please select your country code',
        },
        {
          elementType: 'UxElement',
          stringId: 'requiredField_number',
          value: 'Please enter your phone number',
        },
        {
          elementType: 'UxElement',
          stringId: 'country_code_input_placeholder_text',
          value: 'Country or region',
        },
        {
          elementType: 'UxElement',
          stringId: 'number_label',
          value: 'Phone Number',
        },
        {
          elementType: 'UxElement',
          stringId: 'error_tryagain',
          value: 'The phone number you provided is busy or unavailable. Please check the number and try again.',
        },
        {
          elementType: 'UxElement',
          stringId: 'error_sms_throttled',
          value: 'You hit the limit on the number of text messages. Try again shortly.',
        },
        {
          elementType: 'UxElement',
          stringId: 'error_phone_throttled',
          value: 'You hit the limit on the number of call attempts. Try again shortly.',
        },
        {
          elementType: 'UxElement',
          stringId: 'error_throttled',
          value: 'You hit the limit on the number of verification attempts. Try again shortly.',
        },
        {
          elementType: 'UxElement',
          stringId: 'error_incorrect_code',
          value:
            'The verification code you have entered does not match our records. Please try again, or request a new code.',
        },
        {
          elementType: 'UxElement',
          stringId: 'countryList',
          value:
            '{"DEFAULT":"Country/Region","AF":"Afghanistan","AX":"Åland Islands","AL":"Albania","DZ":"Algeria","AS":"American Samoa","AD":"Andorra","AO":"Angola","AI":"Anguilla","AQ":"Antarctica","AG":"Antigua and Barbuda","AR":"Argentina","AM":"Armenia","AW":"Aruba","AU":"Australia","AT":"Austria","AZ":"Azerbaijan","BS":"Bahamas","BH":"Bahrain","BD":"Bangladesh","BB":"Barbados","BY":"Belarus","BE":"Belgium","BZ":"Belize","BJ":"Benin","BM":"Bermuda","BT":"Bhutan","BO":"Bolivia","BQ":"Bonaire","BA":"Bosnia and Herzegovina","BW":"Botswana","BV":"Bouvet Island","BR":"Brazil","IO":"British Indian Ocean Territory","VG":"British Virgin Islands","BN":"Brunei","BG":"Bulgaria","BF":"Burkina Faso","BI":"Burundi","CV":"Cabo Verde","KH":"Cambodia","CM":"Cameroon","CA":"Canada","KY":"Cayman Islands","CF":"Central African Republic","TD":"Chad","CL":"Chile","CN":"China","CX":"Christmas Island","CC":"Cocos (Keeling) Islands","CO":"Colombia","KM":"Comoros","CG":"Congo","CD":"Congo (DRC)","CK":"Cook Islands","CR":"Costa Rica","CI":"Côte d\'Ivoire","HR":"Croatia","CU":"Cuba","CW":"Curaçao","CY":"Cyprus","CZ":"Czech Republic","DK":"Denmark","DJ":"Djibouti","DM":"Dominica","DO":"Dominican Republic","EC":"Ecuador","EG":"Egypt","SV":"El Salvador","GQ":"Equatorial Guinea","ER":"Eritrea","EE":"Estonia","ET":"Ethiopia","FK":"Falkland Islands","FO":"Faroe Islands","FJ":"Fiji","FI":"Finland","FR":"France","GF":"French Guiana","PF":"French Polynesia","TF":"French Southern Territories","GA":"Gabon","GM":"Gambia","GE":"Georgia","DE":"Germany","GH":"Ghana","GI":"Gibraltar","GR":"Greece","GL":"Greenland","GD":"Grenada","GP":"Guadeloupe","GU":"Guam","GT":"Guatemala","GG":"Guernsey","GN":"Guinea","GW":"Guinea-Bissau","GY":"Guyana","HT":"Haiti","HM":"Heard Island and McDonald Islands","HN":"Honduras","HK":"Hong Kong SAR","HU":"Hungary","IS":"Iceland","IN":"India","ID":"Indonesia","IR":"Iran","IQ":"Iraq","IE":"Ireland","IM":"Isle of Man","IL":"Israel","IT":"Italy","JM":"Jamaica","JP":"Japan","JE":"Jersey","JO":"Jordan","KZ":"Kazakhstan","KE":"Kenya","KI":"Kiribati","KR":"Korea","KW":"Kuwait","KG":"Kyrgyzstan","LA":"Laos","LV":"Latvia","LB":"Lebanon","LS":"Lesotho","LR":"Liberia","LY":"Libya","LI":"Liechtenstein","LT":"Lithuania","LU":"Luxembourg","MO":"Macao SAR","MK":"North Macedonia","MG":"Madagascar","MW":"Malawi","MY":"Malaysia","MV":"Maldives","ML":"Mali","MT":"Malta","MH":"Marshall Islands","MQ":"Martinique","MR":"Mauritania","MU":"Mauritius","YT":"Mayotte","MX":"Mexico","FM":"Micronesia","MD":"Moldova","MC":"Monaco","MN":"Mongolia","ME":"Montenegro","MS":"Montserrat","MA":"Morocco","MZ":"Mozambique","MM":"Myanmar","NA":"Namibia","NR":"Nauru","NP":"Nepal","NL":"Netherlands","NC":"New Caledonia","NZ":"New Zealand","NI":"Nicaragua","NE":"Niger","NG":"Nigeria","NU":"Niue","NF":"Norfolk Island","KP":"North Korea","MP":"Northern Mariana Islands","NO":"Norway","OM":"Oman","PK":"Pakistan","PW":"Palau","PS":"Palestinian Authority","PA":"Panama","PG":"Papua New Guinea","PY":"Paraguay","PE":"Peru","PH":"Philippines","PN":"Pitcairn Islands","PL":"Poland","PT":"Portugal","PR":"Puerto Rico","QA":"Qatar","RE":"Réunion","RO":"Romania","RU":"Russia","RW":"Rwanda","BL":"Saint Barthélemy","KN":"Saint Kitts and Nevis","LC":"Saint Lucia","MF":"Saint Martin","PM":"Saint Pierre and Miquelon","VC":"Saint Vincent and the Grenadines","WS":"Samoa","SM":"San Marino","ST":"São Tomé and Príncipe","SA":"Saudi Arabia","SN":"Senegal","RS":"Serbia","SC":"Seychelles","SL":"Sierra Leone","SG":"Singapore","SX":"Sint Maarten","SK":"Slovakia","SI":"Slovenia","SB":"Solomon Islands","SO":"Somalia","ZA":"South Africa","GS":"South Georgia and South Sandwich Islands","SS":"South Sudan","ES":"Spain","LK":"Sri Lanka","SH":"St Helena, Ascension, Tristan da Cunha","SD":"Sudan","SR":"Suriname","SJ":"Svalbard","SZ":"Swaziland","SE":"Sweden","CH":"Switzerland","SY":"Syria","TW":"Taiwan","TJ":"Tajikistan","TZ":"Tanzania","TH":"Thailand","TL":"Timor-Leste","TG":"Togo","TK":"Tokelau","TO":"Tonga","TT":"Trinidad and Tobago","TN":"Tunisia","TR":"Turkey","TM":"Turkmenistan","TC":"Turks and Caicos Islands","TV":"Tuvalu","UM":"U.S. Outlying Islands","VI":"U.S. Virgin Islands","UG":"Uganda","UA":"Ukraine","AE":"United Arab Emirates","GB":"United Kingdom","US":"United States","UY":"Uruguay","UZ":"Uzbekistan","VU":"Vanuatu","VA":"Vatican City","VE":"Venezuela","VN":"Vietnam","WF":"Wallis and Futuna","YE":"Yemen","ZM":"Zambia","ZW":"Zimbabwe"}',
        },
        {
          elementType: 'UxElement',
          stringId: 'error_448',
          value: 'The phone number you provided is unreachable.',
        },
        {
          elementType: 'UxElement',
          stringId: 'error_449',
          value: 'User has exceeded the number of retry attempts.',
        },
        {
          elementType: 'UxElement',
          stringId: 'verification_code_input_placeholder_text',
          value: 'Verification code',
        },
        {
          elementType: 'ClaimType',
          elementId: 'strongAuthenticationPhoneNumber',
          stringId: 'DisplayName',
          value: 'Phone Number',
        },
      ],
    },
  ],
};
